import videojs from 'video.js'

declare global {
  interface Window {
    hyphenopolyConfig: any,
    __videojs: any
  }
}

bootstrapHyphenopolyConfig()

export function bootstrapHyphenopolyConfig() {
  window.hyphenopolyConfig = window.hyphenopolyConfig || {}

  window.hyphenopolyConfig = {
    ...window.hyphenopolyConfig,
    selectors: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', '.course__name'
    ]
  }
}

window.__videojs = videojs
